import React from 'react';

import usePageTitle from '../../utils/hooks/use_page_title';

import LinkLabel from '../common/Labels/LinkLabel';

export const PageNotFound = ({
  modelID, pipelineID, orchestrationID, modelVersion = null, pipelineVersion = null
}) => {
  const pageTitle = `${modelID ? 'Model not found' : orchestrationID ? 'Workload not found' : 'Page not found'} | Wallaroo`
  usePageTitle(pageTitle);

  return (
    <div className="mt-8 flex flex-col items-center justify-start">
      {modelID ? (
        <>
          <h2 className="text-4xl">Model not found</h2>
          <h3 className="mt-2 text-2xl">
            The model: <span className="font-bold">{modelID} {modelVersion}</span> doesn&apos;t exist
          </h3>
        </>
      ) : pipelineID ? (
        <>
          <h2 className="text-4xl">Pipeline not found</h2>
          <h3 className="mt-2 text-2xl">
            The pipeline: <span className="font-bold">{pipelineID} {pipelineVersion}</span> doesn&apos;t exist
          </h3>
        </>
      ) : orchestrationID ? (
        <>
          <h2 className="text-4xl">Workload not found</h2>
          <h3 className="mt-2 text-2xl">
            The workload: <span className="font-bold">{orchestrationID}</span> doesn&apos;t exist
          </h3>
        </>
      ) :(
        <h2 className="text-4xl">Page not found</h2>
      )}

      <LinkLabel to="/" className="mt-8 underline" size="lg">
        Back to the home page
      </LinkLabel>
    </div>
  );
};
export default PageNotFound;
